import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/auth/useAuth";

export default function UnauthorizedPage() {
  const { t } = useTranslation();
  const { logout } = useAuth();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-2xl font-bold">{t("auth.unauthorized")}</h1>
      <p className="text-[var(--muted-foreground)]">
        {t("auth.unauthorizedDesc")}
      </p>
      <button
        onClick={logout}
        className="rounded bg-[var(--primary)] px-4 py-2 text-white"
      >
        {t("auth.logout")}
      </button>
    </div>
  );
}
